import { useContext } from 'react';
import { Navigate, Outlet } from 'react-router';

import { AuthContext } from '../context/auth-context.tsx';
import { Loading } from '../loading.tsx';

export const LoginRoute = () => {
  const { user, loading } = useContext(AuthContext);

  if (loading) return <Loading />;
  if (user) return <Navigate to='/' />;

  return <Outlet />;
};
